export default __webpack_public_path__ + "/dist/images/market-place-icon.27af723595876581d00c70c2fa666f01.svg";